import Loadable from '../../components/loadable';

const CancellationPolicyForm = Loadable({
  loader: () => import('../../pages/account_profile/cancellation_policy_form'),
});

angular.module('gym').value('CancellationPolicyForm', CancellationPolicyForm);
